export default __webpack_public_path__ + "static/media/Fredoka-SemiBold.b0360fc4.ttf";